import { createAddon } from 'Addons/combine.ts';
import initialize from './initialize.ts';

export default createAddon('search', { enabled: true, initialize });
